export default "__VITE_ASSET__DdaegYiV__"